/**
 * API Configuration Utility
 * 
 * Automatically determines the correct API URL based on hostname.
 * This ensures production (stackranked.ai) uses its own domain while
 * Emergent preview environments use the dynamically assigned URL.
 */

export const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  
  // Production domains - use same origin for API
  if (hostname === 'stackranked.ai' || hostname === 'www.stackranked.ai') {
    return 'https://stackranked.ai';
  }
  
  // Emergent preview or local development - use env variable
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export a constant for immediate use
export const API_BASE_URL = getApiBaseUrl();
